import React from "react";
import { Link } from "react-router-dom";

export default function LayoutSideBar() {
  const role = localStorage.getItem("roleName");
  return (
    <div className="app-menu navbar-menu">
      <div className="navbar-brand-box">
        <Link to={"/"} className="logo logo-light">
          <span className="logo-lg" style={{ color: "#fff", fontSize: "20px" }}>
            TEAM SRIVEN MANAGEMENT
          </span>
        </Link>
        <button
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          id="vertical-hover"
        >
          <i className="ri-record-circle-line" />
        </button>
      </div>
      <div id="scrollbar">
        <div className="container-fluid">
          <div id="two-column-menu"></div>
          <ul className="navbar-nav" id="navbar-nav">
            {["ADMIN", "SUPERADMIN"].includes(role) && (
              <>
                <li className="nav-item">
                  <Link className="nav-link menu-link" to={"/admindashboard"}>
                    <i className="ri-store-line"></i>
                    <span data-key="t-dashboards">Dashboard</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarSettings"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarSettings"
                  >
                    <i className="ri-tools-line"></i>

                    <span data-key="t-authentication">Services</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarSettings">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/clientservice"}
                        >
                          <span data-key="t-dashboards">Client Service</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/generatetasks"}
                        >
                          <span data-key="t-dashboards">Generate Tasks</span>
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/servicetasklist"}
                        >
                          <span data-key="t-dashboards">All Tasks</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarStaffInfo"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarStaffInfo"
                  >
                    <i className="ri-money-dollar-circle-line"></i>

                    <span data-key="t-authentication">Payments</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarStaffInfo">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/payment"}>
                          <span data-key="t-dashboards">
                            {" "}
                            Clients Payments{" "}
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarStaffInfo"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarStaffInfo"
                  >
                    <i className="ri-team-line"></i>

                    <span data-key="t-authentication">Clients-Info</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarStaffInfo">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/allclients"}>
                          <span data-key="t-dashboards">Clients</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/clientfolder"}
                        >
                          <span data-key="t-dashboards">Clients Folders</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarStaffInfo"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarStaffInfo"
                  >
                    <i className="ri-team-line"></i>

                    <span data-key="t-authentication">Staffs-Info</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarStaffInfo">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/designation"}
                        >
                          <span data-key="t-dashboards"> Add designation</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/staff"}>
                          <span data-key="t-dashboards"> Create staff</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/attendance"}>
                          <span data-key="t-dashboards"> Staff attendance</span>
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/overtime"}>
                          <span data-key="t-dashboards">
                            Add overTime amount
                          </span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/salary"}>
                          <span data-key="t-dashboards">
                            {" "}
                            Create staff salary
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarReports"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarReports"
                  >
                    <i className="las la-chart-pie"></i>
                    <span data-key="t-authentication"> Reports</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarReports">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/servicetaskreports"}
                        >
                          <span data-key="t-dashboards">
                            {" "}
                            ServiceTask Report
                          </span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/paymentreport"}
                        >
                          <span data-key="t-dashboards">
                            {" "}
                            Clients Payment Report
                          </span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/attendancereport"}
                        >
                          <span data-key="t-dashboards">
                            {" "}
                            Staffs Attendance Report
                          </span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/payoutreport"}
                        >
                          <span data-key="t-dashboards">
                            {" "}
                            Staffs Payout Report
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarMasters"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarMasters"
                  >
                    <i className="ri-star-line"></i>

                    <span data-key="t-authentication">Masters</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarMasters">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/category"}>
                          <span data-key="t-dashboards">Categories</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/systemtask"}>
                          <span data-key="t-dashboards">systemtasks</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/clientcategory"}
                        >
                          <span data-key="t-dashboards">Client categories</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/importclients"}
                        >
                          <span data-key="t-dashboards">Import clients</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/ipaddress"}>
                          <span data-key="t-dashboards">IPaddresses</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarMasters"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarMasters"
                  >
                    <i className="ri-building-line"></i>

                    <span data-key="t-authentication">Settings</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarMasters">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/profile"}>
                          <span data-key="t-dashboards"> My Profile</span>
                        </Link>
                        <Link
                          className="nav-link menu-link"
                          to={"/changepassword"}
                        >
                          <span data-key="t-dashboards"> Change Password</span>
                        </Link>
                        <Link className="nav-link menu-link" to={"/companies"}>
                          <span data-key="t-dashboards"> Channel Partners</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/loginhistory"}
                        >
                          <span data-key="t-dashboards">Login History</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              </>
            )}
            {role === "SUBADMIN" && (
              <>
                <li className="nav-item">
                  <Link
                    className="nav-link menu-link"
                    to={"/subadmindashboard"}
                  >
                    <i className="ri-store-line"></i>
                    <span data-key="t-dashboards">Dashboard</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarSettings"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarSettings"
                  >
                    <i className="ri-tools-line"></i>

                    <span data-key="t-authentication">Services</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarSettings">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/clientservice"}
                        >
                          <span data-key="t-dashboards">Client Service</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/generatetasks"}
                        >
                          <span data-key="t-dashboards">Generate Tasks</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarReports"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarReports"
                  >
                    <i className="las la-chart-pie"></i>
                    <span data-key="t-authentication"> Reports</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarReports">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/servicetaskreports"}
                        >
                          <span data-key="t-dashboards">
                            {" "}
                            ServiceTask Report
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarStaffInfo"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarStaffInfo"
                  >
                    <i className="ri-team-line"></i>

                    <span data-key="t-authentication">Clients-Info</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarStaffInfo">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/allclients"}>
                          <span data-key="t-dashboards">All Clients</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/clientfolder"}
                        >
                          <span data-key="t-dashboards">Clients Folders</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarStaffInfo"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarStaffInfo"
                  >
                    <i className="ri-team-line"></i>

                    <span data-key="t-authentication">Staffs-Info</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarStaffInfo">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/staff"}>
                          <span data-key="t-dashboards"> Create staff</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarMasters"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarMasters"
                  >
                    <i className="ri-star-line"></i>

                    <span data-key="t-authentication">Masters</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarMasters">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/category"}>
                          <span data-key="t-dashboards">Categories</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/systemtask"}>
                          <span data-key="t-dashboards">systemtasks</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/clientcategory"}
                        >
                          <span data-key="t-dashboards">Client category</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarMasters"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarMasters"
                  >
                    <i className="ri-building-line"></i>

                    <span data-key="t-authentication">Settings</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarMasters">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/profile"}>
                          <span data-key="t-dashboards"> My Profile</span>
                        </Link>
                        <Link
                          className="nav-link menu-link"
                          to={"/changepassword"}
                        >
                          <span data-key="t-dashboards"> Change Password</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <Link to={"/logout"} className="nav-link menu-link">
                    <i className="mdi mdi-logout" />{" "}
                    <span className="align-middle" data-key="t-logout">
                      Logout
                    </span>
                  </Link>
                </li>
              </>
            )}
            {role === "STAFF" && (
              <>
                <li className="nav-item">
                  <Link className="nav-link menu-link" to={"/staffdashboard"}>
                    <i className="ri-store-line"></i>
                    <span data-key="t-dashboards">Dashboard</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarAttendance"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarAttendance"
                  >
                    <i className="ri-team-line"></i>

                    <span data-key="t-authentication">Clients-Info</span>
                  </a>
                  <div
                    className="collapse menu-dropdown"
                    id="sidebarAttendance"
                  >
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/clients"}>
                          <span data-key="t-dashboards">Clients</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link menu-link"
                          to={"/clientfolder"}
                        >
                          <span data-key="t-dashboards">Client Folders</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <Link className="nav-link menu-link" to={"/attendancelist"}>
                  <i className="las la-chart-pie"></i>
                  <span data-key="t-dashboards"> My Attendance</span>
                </Link>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarMasters"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarMasters"
                  >
                    <i className="ri-building-line"></i>

                    <span data-key="t-authentication">Settings</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarMasters">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/profile"}>
                          <span data-key="t-dashboards"> My Profile</span>
                        </Link>
                        <Link
                          className="nav-link menu-link"
                          to={"/changepassword"}
                        >
                          <span data-key="t-dashboards"> Change Password</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <Link to={"/logout"} className="nav-link menu-link">
                    <i className="mdi mdi-logout" />{" "}
                    <span className="align-middle" data-key="t-logout">
                      Logout
                    </span>
                  </Link>
                </li>
              </>
            )}
            {role === "CLIENT" && (
              <>
                <li className="nav-item">
                  <Link className="nav-link menu-link" to={"/clientdashboard"}>
                    <i className="ri-store-line"></i>
                    <span data-key="t-dashboards">Dashboard</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link menu-link" to={"/clientpayment"}>
                    <i className="ri-wallet-2-line"></i>
                    <span data-key="t-dashboards">Payments History</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarMasters"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarMasters"
                  >
                    <i className="ri-building-line"></i>

                    <span data-key="t-authentication">Settings</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarMasters">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link className="nav-link menu-link" to={"/profile"}>
                          <span data-key="t-dashboards"> My Profile</span>
                        </Link>
                        <Link
                          className="nav-link menu-link"
                          to={"/changepassword"}
                        >
                          <span data-key="t-dashboards"> Change Password</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <Link to={"/logout"} className="nav-link menu-link">
                    <i className="mdi mdi-logout" />{" "}
                    <span className="align-middle" data-key="t-logout">
                      Logout
                    </span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
